// ── no-javascript body class ────────────────────────────────────────────────
// Classic layouts add class="no-javascript" on <body> (x.lib.pub.html.body)
// and removed it via jQuery/Prototype in an inline block (x.lib.pub.html.meta).
// Shell pages usually don't carry the class, but other configurations may —
// drop it unconditionally. Running with `defer` is earlier than the legacy
// window.load hook, which shortens the no-JS flash.
(function () {
    'use strict';
    document.body.classList.remove('no-javascript');
})();
